import { CommonModel } from '@telialt/models/src/CommonModel';

export const getQueryKeyPrefixBySegment = (segment: CommonModel.Segment) => {
    if (segment === 'b2b') {
        return 'b2b';
    }
    if (segment === 'english') {
        return 'eng';
    }
    if (segment === 'russian') {
        return 'rus';
    }

    return 'b2c';
};
